var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"alert-container"},[_c('p',[_vm._v(_vm._s(`${_vm.message} ${_vm.message && '-'} ${_vm.status}`))])])
}
var staticRenderFns = []

export { render, staticRenderFns }